export default __webpack_public_path__ + "static/media/article1.0e2b62e9.jpeg";